// WE NEED TO "MOVE" THE OMNIBUS MARKUP TO THE PRICE BASED ON THE FIGMA DESIGN
document.addEventListener('DOMContentLoaded', function () {
  const omnibusElement = document.querySelector(
    '[id*="sniffie_omnibus_pricing_omnibus_price_history"]'
  );
  const priceWrapperElement = document.getElementById('pdp-price');

  if (omnibusElement && priceWrapperElement) {
    priceWrapperElement.appendChild(omnibusElement);
  }
});
